export * from "./Text";
export { default } from "./Text";
export { default as TextSeo } from "./TextSeo";
